import React from 'react';
import { connect } from 'redux-bundler-react';
import NotificationPane from '../core-plugins/notifications/notifications';
import NorthRegion from './north-region';
import SouthRegion from './south-region';
import ModalWindow from './modal-window';
import LoadingOverlay from './loading-overlay';

class Corpsmap extends React.Component {
  constructor(props){
    super(props);
    const { northHeight, southHeight } = props;
    this.state = {
      hNorth: northHeight,
      hSouth: southHeight,
      lastY: null
    }
    this.renderNorthRegion = this.renderNorthRegion.bind(this);
    this.renderSouthRegion = this.renderSouthRegion.bind(this);
    this.renderModalWindow = this.renderModalWindow.bind(this);
    this.renderLoadingMask = this.renderLoadingMask.bind(this);
    this.resize = this.resize.bind(this);
    this.updateStore = this.updateStore.bind(this);
  }

  componentDidUpdate(){
    const { northHeight, southHeight } = this.props;
    if(northHeight !== this.state.hNorth){
      this.setState({
        hNorth: northHeight,
        hSouth: southHeight,
        lastY: null
      })
    }
  }

  renderNorthRegion(){
    const { hNorth } = this.state;
    return (
      <NorthRegion height={hNorth} />
    )
  }

  renderSouthRegion(){
    const { hSouth } = this.state;
    const { doCloseSouthRegion, theme } = this.props;
    if(!hSouth) return null;
    return (
      <div>
        <div draggable="true" onDrag={ this.resize } onDragEnd={ this.updateStore } className={ theme + " n-s-drag-handle"}>
          <span onClick={ doCloseSouthRegion } className="pull-right">
            <i className="mdi mdi-close"></i>
          </span>
        </div>
        <SouthRegion height={hSouth-5} />
      </div>
    )
  }

  renderModalWindow(){
    return <ModalWindow />
  }

  renderLoadingMask(){
    const { pluginsAreLoading } = this.props;
    if(!pluginsAreLoading) return null;
    return (
      <div style={{position:'absolute',top:0,bottom:0,left:0,right:0,backgroundColor:'#555',opacity:0.5}}>
        <h1>loading...</h1>
      </div>
    )
  }

  resize(e){
    e.preventDefault();
    const { lastY, hNorth, hSouth } = this.state;
    const newY = e.clientY;
    if(newY && lastY){
      const delta = lastY - newY
      this.setState({
        hNorth: hNorth - delta,
        hSouth: hSouth + delta,
        lastY: newY
      })
    }else{
      this.setState({
        lastY: newY
      })
    }
  }

  updateStore(){
    const { doResizeSouthRegion } = this.props;
    doResizeSouthRegion(this.state);
  }

  render(){
    return (
      <div className="container-fluid" style={{padding:0}}>
        { this.renderNorthRegion() }
        { this.renderSouthRegion() }
        <ModalWindow />
        <NotificationPane />
        { this.renderLoadingMask() }
        <LoadingOverlay />
      </div>
    )
  }
}

export default connect(
  'selectTheme',
  'selectPluginsAreLoading',
  'selectNorthHeight', 
  'selectSouthHeight', 
  'doResizeSouthRegion',
  'doCloseSouthRegion',
  Corpsmap
);